import React, { useState, useEffect } from 'react';
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { saveTechnician } from './actions/action';
import toast from 'react-hot-toast';

const initialFormState = {
  emp_id: '',
  technician_name: '',
  phone: '',
  email: '',
  department: 'purifier',
  location: 'Dubai',
  status: 'active',
};

const CreateTechnicians = ({ isOpen, toggle, editData }) => {
  const users = JSON.parse(localStorage?.getItem('authUser'));
  const dispatch = useDispatch();
  const [form, setForm] = useState(initialFormState);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (editData) {
        setForm({
          emp_id: editData.emp_id || '',
          technician_name: editData.technician_name || '',
          phone: editData.phone || '',
          email: editData.email || '',
          department: editData.department || 'purifier',
          location: editData.location || 'Dubai',
          status: editData.status || 'active',
        });
      } else {
        setForm(initialFormState);
      }
    }
  }, [isOpen, editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.emp_id || !form.technician_name || !form.phone || !form.email) {
      toast.error("Please fill all required fields");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        ...form,
        created_by: users?.salesPersonCode,
      };
      
      const response = await saveTechnician({ data: payload, dispatch });
      
      if (response?.code === 100) {
        toast.success(editData ? 'Technician updated successfully!' : 'Technician created successfully!');
        toggle();
      } else {
        toast.error(response?.message || 'Failed to save technician');
      }
    } catch (error) {
      console.error("Error saving technician:", error);
      toast.error('Something went wrong!');
    } finally {
      setIsLoading(false);
    }
  };

  const locations = [
    "Abu Dhabi", "Dubai", "Sharjah", "Ajman", "Umm Al Quwain", "Ras Al Khaimah", "Fujairah"
  ];

  const departments = [
    { value: 'purifier', label: 'Purifier' }
  ];

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      style={{ width: '500px' }}
    >
      <OffcanvasHeader toggle={toggle}>
        {editData ? 'Edit Technician' : 'Create Technician'}
      </OffcanvasHeader>
      <OffcanvasBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="emp_id">Employee ID <span className="text-danger">*</span></Label>
            <Input
              type="text"
              name="emp_id"
              id="emp_id"
              placeholder="Enter EMP ID"
              value={form.emp_id}
              onChange={handleChange}
              disabled={!!editData}
              required
            />
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="technician_name">Technician Name <span className="text-danger">*</span></Label>
            <Input
              type="text"
              name="technician_name"
              id="technician_name"
              placeholder="Enter Name"
              value={form.technician_name}
              onChange={handleChange}
              required
            />
          </FormGroup>

          <Row className="mt-3">
            <Col md={6}>
              <FormGroup>
                <Label for="phone">Phone <span className="text-danger">*</span></Label>
                <Input
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder="Enter Phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="email">Email <span className="text-danger">*</span></Label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter Email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <FormGroup>
                <Label for="department">Department</Label>
                <Input
                  type="select"
                  name="department"
                  id="department"
                  value={form.department}
                  onChange={handleChange}
                >
                  {departments.map(dept => (
                    <option key={dept.value} value={dept.value}>{dept.label}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="location">Location</Label>
                <Input
                  type="select"
                  name="location"
                  id="location"
                  value={form.location}
                  onChange={handleChange}
                >
                  {locations.map(loc => (
                    <option key={loc} value={loc}>{loc}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <FormGroup className="mt-3">
            <Label for="status">Status</Label>
            <div>
              <FormGroup check inline>
                <Label check>
                  <Input 
                    type="radio" 
                    name="status" 
                    value="active" 
                    checked={form.status === 'active'}
                    onChange={handleChange}
                  />{' '}
                  Active
                </Label>
              </FormGroup>
              <FormGroup check inline>
                <Label check>
                  <Input 
                    type="radio" 
                    name="status" 
                    value="inactive" 
                    checked={form.status === 'inactive'}
                    onChange={handleChange}
                  />{' '}
                  Inactive
                </Label>
              </FormGroup>
            </div>
          </FormGroup>

          <div className="mt-5 d-flex gap-2">
            <Button color="secondary" type="submit" className="flex-grow-1" disabled={isLoading}>
              {isLoading ? 'Saving...' : (editData ? 'Update Technician' : 'Create Technician')}
            </Button>
            <Button color="light" type="button" onClick={toggle} className="px-4">
              Cancel
            </Button>
          </div>
        </Form>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default CreateTechnicians;
